import { GET_TTFB_MANUFACTURERS_REQUEST,
    GET_TTFB_MANUFACTURERS_SUCCESS,
    GET_TTFB_MANUFACTURERS_FAILURE,
    RESET_TTFB_MANUFACTURERS } from '../../actions/business/constants';

const INITIAL_STATE = {
    fetching: false,
    page: 1,
    data: null,
    error: false
}

export default function partners(state = INITIAL_STATE, action) {
    switch(action.type) {
        case GET_TTFB_MANUFACTURERS_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case GET_TTFB_MANUFACTURERS_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: state.page === 1
                    ? action.payload
                    : {
                        ...state.data,
                        data: [...state.data.data,
                        ...action.payload.data]
                    }, // add more
                hasFetched: true,
                page: state.page + 1,
                hasEnd: (!action.payload.data.length
                    || (!!action.payload.data.length
                        && action.payload.data.length < 20))
            }
        case GET_TTFB_MANUFACTURERS_FAILURE:
            return {
                ...state,
                ...(!action.error.__CANCEL__ && {
                    error: true,
                    errorMsg: action.error
                }),
                fetching: false,
            }
        case RESET_TTFB_MANUFACTURERS:
            return INITIAL_STATE
        default:
            return state;
    }
}